module.exports = __webpack_public_path__ + "media/images/product_lines/car/info_m-52e2d30d3449965c2334ef73f3e9a185.svg";